module.exports = __webpack_public_path__ + "files/c5505ddc4d6b9d72ec99ffb70d3873be.png";